// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { layers } from '@atlaskit/theme/constants';
import { N20, N40 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// taken from https://stash.atlassian.com/projects/confcloud/repos/confluence-frontend/browse/next/packages/template-preview/src/PreviewFrame.tsx
const PREVIEW_MIN_WIDTH = 480;
const TEMPLATE_PANEL_WIDTH = 320;
const DISTANCE_FROM_ITEM = 32;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HoverPreviewContainer = styled.div({
	display: 'flex',
	flexDirection: 'column',
	zIndex: layers.tooltip(),
	background: token('elevation.surface', 'white'),
	border: `1px solid ${token('color.border', N20)}`,
	borderRadius: '3px',
	boxShadow: token(
		'elevation.shadow.overlay',
		'0px 0px 1px rgba(9, 30, 66, 0.31), 0px 3px 5px rgba(9, 30, 66, 0.2)',
	),
	width: '40vw',
	maxWidth: '600px',
	minWidth: `${PREVIEW_MIN_WIDTH}px`,
	maxHeight: '85%',
	backgroundColor: token('elevation.surface'),
	// do not show preview on very narrow devices
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	[`@media screen and (max-width: ${
		TEMPLATE_PANEL_WIDTH + DISTANCE_FROM_ITEM + PREVIEW_MIN_WIDTH
	}px)`]: {
		display: 'none',
	},
});

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateInfo = styled.div({
	height: '53px',
	padding: `14px ${token('space.300', '24px')}`,
	boxSizing: 'border-box',
	display: 'flex',
	alignItems: 'center',
	borderBottom: `1px solid ${token('color.border', N40)}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const TemplateName = styled.div`
	font: ${token('font.heading.small')};
	margin: 0 0 0 ${token('space.100', '8px')};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Icon = styled.div({
	alignSelf: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Preview = styled.div({
	overflowY: 'auto',
});
